import { Stack } from '@mui/material';

import { classNames } from 'shared/lib/utils/classNames';

import cls from './Tag.module.scss';
import { TTagColor, TagColor } from './TagTypes';

interface TagProps {
  color: TTagColor;
  className?: string;
  children: React.ReactNode;
}

export const Tag = (props: TagProps) => {
  const { color, className, children } = props;

  const tagColorClass = {
    [cls.TagRedColor]: color === TagColor.RED,
    [cls.TagGreenColor]: color === TagColor.GREEN,
    [cls.TagBlueColor]: color === TagColor.BLUE,
    [cls.TagYellowColor]: color === TagColor.YELLOW,
    [cls.TagWhiteColor]: color === TagColor.WHITE,
    [cls.TagGreyColor]: color === TagColor.GREY,
  };

  return (
    <Stack
      display='inline-flex'
      className={classNames(cls.TagWrapper, tagColorClass, [className])}
    >
      {children}
    </Stack>
  );
};
